module.exports = __webpack_public_path__ + "static/handling-plants-a3f6f18a8bbb1b68eda9b8941f99503b.jpg";